import React, { useEffect } from "react";
import { AssetInterface } from "../../../../store/community/assetsSlice";

import {Button, DatePicker, Form, Input, Select} from "antd";
import FileDropzone from "../../../../componets/FileDropzone";
import { filterOption } from "../../../../helpers/FormHelper";
import { EntityId } from "@reduxjs/toolkit";
import { useAppSelector } from "../../../../store/hooks";
import { selectCategoryEntities, selectCategoryIds } from "../../../../store/community/categoriesSlice";
import { selectKindEntities, selectKindIds } from "../../../../store/community/kindsSlice";

interface propsInterface {
  params?: AssetInterface | undefined;
  onFinish: Function;
}

const _Form = ({ params, onFinish }: propsInterface) => {
  const categories = useAppSelector(selectCategoryEntities);
  const categoryIds = useAppSelector(selectCategoryIds);
  const kinds = useAppSelector(selectKindEntities);
  const kindIds = useAppSelector(selectKindIds);
  const [form] = Form.useForm();
  const dateConfig = {
    rules: [{ required: true, message: 'Please select time!' }],
  };

  useEffect(() => {
    form.resetFields();
  }, [params, form]);

  const renderCategoryOption = (id: EntityId) => {
    const item = categories[id];

    if (!item) {
      return null;
    }

    return <Select.Option key={id} value={id} title={item.name}>{item.name}</Select.Option>
  }

  const renderCategories = () => {
    return (
      <Form.Item
        name='category_id'
        label="Select a category"
      >
        <Select
          allowClear
          showSearch
          filterOption={filterOption}
          placeholder='Select a category'
        >
          {categories && categoryIds.map(renderCategoryOption)}
        </Select>
      </Form.Item>
    )
  }

  const renderKindOption = (id: EntityId) => {
    const item = kinds[id];

    if (!item) {
      return null;
    }

    return <Select.Option key={id} value={id} title={item.name}>{item.name}</Select.Option>
  }

  const renderKinds = () => {
    if (kindIds.length === 0) {
      return null;
    }

    return (
      <Form.Item
        name='kind_id'
        label="Select a kind"
        tooltip='Left empty, the asset inherits the kind from its category'
      >
        <Select
          allowClear
          showSearch
          filterOption={filterOption}
          placeholder='Select a kind'
        >
          {kinds && kindIds.map(renderKindOption)}
        </Select>
      </Form.Item>
    )
  }

  return (
    <Form
      form={form}
      onFinish={values => onFinish(values)}
      layout="vertical"
      className='v-form'
      initialValues={params}
    >
      <div className='v-group-dropzone'>
        <FileDropzone name='thumbnail' label='Thumbnail' preview={params?.thumbnail_url} />
        <FileDropzone name='file' label='File' preview={params?.file_url} />
      </div>

      <Form.Item name='app_id' noStyle>
        <Input type="hidden" />
      </Form.Item>

      {renderKinds()}
      {renderCategories()}

      <Form.Item name='title' label="Title">
        <Input placeholder='Title' />
      </Form.Item>

      <Form.Item name="moment_date" label='Published_at' {...dateConfig}>
        <DatePicker showTime />
      </Form.Item>

      <Form.Item name='description' label="Description">
        <Input.TextArea rows={4} />
      </Form.Item>

      <Form.Item name='search_text' label="Search Text">
        <Input.TextArea rows={3} />
      </Form.Item>

      <Form.Item>
        <Button className="v-btn v-btn-primary" type="primary" htmlType="submit">
          Submit
        </Button>
      </Form.Item>
    </Form>
  )
}

export default _Form;
